module.exports = __webpack_public_path__ + "img/prize-04.d4bf5d12.png";